import { ApiError } from '@/api/http'

const CODE_MAP: Record<string, string> = {
  '000007': '資料已存在,請重新整理後再試',
  '000008': '販賣機未上線',
  '140000': '支付失敗,請改用其他支付方式或稍後再試',
  '140002': '販賣機尚未回報可交易,請稍候',
  '140003': '交易狀態不正確,請重新掃碼',
  '140004': '已選現金付款,不可改用電子支付',
  '999999': '操作失敗,請稍後再試',
  NETWORK: '網路連線異常,請檢查網路後重試',
}

const MESSAGE_MAP: Array<{ test: RegExp; text: string }> = [
  { test: /machine model is not no-screen/i, text: '此販賣機不支援掃碼購買' },
  {
    test: /machine busy with another payment/i,
    text:
      '販賣機目前有其他交易進行中,請稍候\n如確認無他人進行交易,請按販賣機的退幣鈕,再重試',
  },
  { test: /session not in WAITING_PAY/i, text: '目前狀態無法付款,請重新掃碼' },
  { test: /session not in PAID/i, text: '目前狀態無法開立發票' },
]

/**
 * 後端有時把內部錯誤直接包成「系統異常(...技術細節...)」或吐出 SQL / 例外 / 堆疊訊息。
 * 這些**不可顯示給使用者**:
 *  - 「系統異常(xxx)」一律收斂成「系統異常」(不外漏括號內後端內容)
 *  - 其他明顯技術性內容(Exception / SQL / MyBatis `###` / 堆疊)→ 回通用 fallback
 *  - 其餘(短、非技術性的後端友善訊息,如「販賣機尚未回報可交易」)照顯示
 */
function sanitizeServerMessage(msg: string | undefined, fallback: string): string {
  const trimmed = (msg ?? '').trim()
  if (!trimmed) return fallback
  if (trimmed.startsWith('系統異常')) return '系統異常'
  if (/(Exception|SQLSyntax|### Error|### SQL|bad SQL grammar|\bat [\w.$]+\()/i.test(trimmed)) {
    return fallback
  }
  return trimmed
}

export function friendlyError(err: unknown, fallback = '系統錯誤,請稍後再試'): string {
  if (err instanceof ApiError) {
    for (const m of MESSAGE_MAP) {
      if (err.message && m.test.test(err.message)) return m.text
    }
    if (err.code in CODE_MAP) return CODE_MAP[err.code]
    return sanitizeServerMessage(err.message, fallback)
  }
  if (err instanceof Error) return sanitizeServerMessage(err.message, fallback)
  return fallback
}
